import React, { Component } from "react";
import { Cell } from "fixed-data-table-2";
import {
  DataPeriod,
  EvidenceColumn,
  EvidenceColumnGroup,
  EvidenceType,
  MeasurementType,
  PossibleValue,
  Student,
  StudentEntry,
} from "../../../../../../../store/onboarding/types";
import Select from "react-select";
import { Button, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faPlusCircle,
  faSquare,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import DataCell from "./DataCell";
import { StudentRowEditing } from "../../EvidenceTable";
import { Styles } from "react-select/src/styles";
import DiagnosticSkillDataEntryCell from "./DiagnosticSkillDataEntryCell";
import TargetBehaviorEmptyCell from "./TargetBehaviorEmptyCell";
import { bindActionCreators, Dispatch } from "redux";
import { openSkillFocusesModal } from "../../../../../../../store/groups/actions";
import { connect } from "react-redux";
import InterviewEntryCell from "./InterviewEntryCell";
import BehaviorDataCell from "./BehaviorDataCell";
import BehaviorScreenerDataEntryCell from "./BehaviorScreenerDataEntryCell";
import { showConfirmDialog } from "../../../../../../../store/confirm-dialog/actions";
import { deleteDataStudentEntry } from "../../../../../../../store/onboarding/actions";

type OwnProps = {
  isReadonly?: boolean;
  studentEditingRows: Array<StudentRowEditing>;
  evidenceColumn: EvidenceColumn;
  dataPeriod?: DataPeriod;
  evidenceColumnGroupId: number;
  student: Student;
  evidenceColumnGroup?: EvidenceColumnGroup;
  loadingValueOfDSEtoDataPeriod?: boolean;
  onSelectedValueChange: (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number
  ) => any;
  onStudentRowEditingChange: (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number
  ) => any;
  onDiagnosticFollowUpEditingChange: (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number,
    value?: string
  ) => any;
  onKeyDown: (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number
  ) => any;
  onChangesApply: (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number,
    value?: number | boolean
  ) => any;
  onCellEditFormChange: (
    evidenceColumnGroupId: number,
    evidenceColumnId: number,
    studentId: number,
    value?: string
  ) => any;
};

type DispatchProps = {
  openSkillFocusesModal: (studentEntry?: StudentEntry) => any;
  showConfirmDialog: (confirmObj:any) => any;
  deleteStudentScoreEntry: (studentEntryId: number) => any;
};

type Props = OwnProps & DispatchProps;

const CustomSelectStyles: Partial<Styles<PossibleValue, boolean>> = {
  control: (provided) => ({
    ...provided,
    minHeight: "25px",
    // lineHeight: "25px",
    fontSize: "14pt",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "25px",
  }),
  placeholder: (provided) => ({
    ...provided,
    height: "25px",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "25px",
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: "5px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "5px",
  }),
};

class DataStudentEntryCell extends Component<Props> {
  handleFocus = (event: any) => {
    event.target.select();
  };

  getEmptyCell = (
    evidenceColumnGroupId: number,
    evidenceColumn: EvidenceColumn,
    student: Student,
    studentEntry?: StudentEntry
  ) => {
    const { onCellEditFormChange } = this.props;

    if (this.props.isReadonly) {
      return <Cell />;
    }

    switch (evidenceColumn.evidence_type) {
      case EvidenceType.Data:
        return (
          this.props.evidenceColumnGroup?.assessment.name !== 'SRSS' 
          ? 
            <Cell
              onClick={onCellEditFormChange(
                evidenceColumnGroupId,
                evidenceColumn.id,
                student.id!
              )}
              className="dataTableCellEmpty"
            >
              <FontAwesomeIcon icon={faPlusCircle} />
            </Cell>
          : <Cell/>
        );
      case EvidenceType.DiagnosticFollowUp:
        return (
          <Cell
              onClick={onCellEditFormChange(
                evidenceColumnGroupId,
                evidenceColumn.id,
                student.id!,
                studentEntry?.value
              )}
              className="dataTableCellWithButton"
            >
            {!studentEntry?.value 
            ? <button className="blueBtnSm">Follow Up</button>
            : <FontAwesomeIcon size="lg"  style={{color: "#1e88e5"}}  icon={faSquare} />  
            }  
            </Cell>
        )
        break;
      case EvidenceType.DiagnosticInfo:
        return (
          <DiagnosticSkillDataEntryCell
            studentEntry={studentEntry}
            studentId={student.id!}
            dataPeriod={this.props.dataPeriod}
          />
        );
      // case EvidenceType.Interview:
      case EvidenceType.NeedAreas:
        return (
          <Cell className="dataTableCellEmpty">
            <FontAwesomeIcon icon={faPlusCircle} />
          </Cell>
        );
      case EvidenceType.BehaviorScreener:
        return (
          <BehaviorScreenerDataEntryCell
            //studentEntry={studentEntry}
            student={student}
            evidenceColumnGroupId = {evidenceColumnGroupId}
            evidenceColumn = {evidenceColumn}
          />
        );
      case EvidenceType.TargetBehavior:
        return <div />;
      case EvidenceType.ExistingBehavior:
        return <TargetBehaviorEmptyCell student={student} />;
    }
  };

  
  render() {

    let {
      evidenceColumn,
      dataPeriod,
      student,
      evidenceColumnGroupId,
      studentEditingRows,
      onSelectedValueChange,
      onStudentRowEditingChange,
      onDiagnosticFollowUpEditingChange,
      onKeyDown,
      onCellEditFormChange,
      onChangesApply,
    } = this.props;
    // demo code
    // if(evidenceColumn.evidence_type == 0) {
    //   evidenceColumn = {
    //       ...evidenceColumn,
    //       student_entries : [...evidenceColumn.student_entries.map((se) => {
    //       if(se.student_id == 124779) {
    //         se = {
    //           ...se,
    //           gating_file_value: evidenceColumn.measurement.column_name == 'NWF-CLS' 
    //                               ? 'Discontinued' 
    //                                 : evidenceColumn.measurement.column_name == 'WRF'
    //                                    ? 'Tested Out' 
    //                                     : null
    //         }
    //       } else {
    //         se = {
    //           ...se,
    //           gating_file_value: null
    //         }
    //       }
    //       return se;
    //     })]
    //   }
    // }
    // end demo code
    const entry: StudentEntry | undefined = evidenceColumn.student_entries.find(
      (entry) => entry.student_id === student.id
    );
    const studentRowEditing = studentEditingRows
      .find((x) => x.studentId === student.id)
      ?.evidenceColumnGroups.find(
        (x) => x.evidenceColumnGroupId === evidenceColumnGroupId
      )
      ?.evidenceColumnEditingStatuses.find(
        (x) => x?.evidenceColumnId === evidenceColumn.id
      );
    const isDataEvidence = evidenceColumn.evidence_type === EvidenceType.Data;
    const isCategoryType =
      isDataEvidence &&
      evidenceColumn.measurement?.type === MeasurementType.CATEGORY;

    if (evidenceColumn.evidence_type === EvidenceType.ExistingBehavior) {
      return (
        <BehaviorDataCell
          studentEntry={entry}
          student={student}
          isReadonly={this.props.isReadonly}
        />
      );
    }

    return studentRowEditing?.isEdited && !this.props.isReadonly ? (
      <div className="editableDataCell">
        <div
          style={
            !isCategoryType
              ? { width: evidenceColumn.evidence_type == EvidenceType.DiagnosticFollowUp ? "100%": "65%", marginLeft: "auto", marginRight: "auto" }
              : { width: "100%" }
          }
        >
          {isCategoryType ? (
            <Select
              className="editableDataCellCategory"
              isSearchable={false}
              classNamePrefix="data_cell"
              placeholder="Select..."
              name="possibleValuesSelect"
              value={evidenceColumn.measurement.possible_values!.find(
                (possibleValue) =>
                  possibleValue.order === +studentRowEditing!.value!
              )}
              menuPortalTarget={document.body}
              options={evidenceColumn.measurement.possible_values!}
              getOptionLabel={({ display_name }: PossibleValue) => display_name}
              getOptionValue={({ order }: PossibleValue) => order.toString()}
              onChange={onSelectedValueChange(
                evidenceColumnGroupId,
                evidenceColumn.id,
                student.id!
              )}
              styles={CustomSelectStyles}
            />
          ) : evidenceColumn.evidence_type == EvidenceType.DiagnosticFollowUp
          ? (
            <div className="d-flex justify-content-center">
              <button
                onClick={onCellEditFormChange(
                  evidenceColumnGroupId,
                  evidenceColumn.id,
                  student.id!
                )}
                className="whiteBtnSmXs"
              >
                Cancel
              </button>
              <button
                onClick={() => onDiagnosticFollowUpEditingChange(
                  evidenceColumnGroupId,
                  evidenceColumn.id,
                  student.id!,
                  entry?.value  
                )}
                className="blueBtnSmXs ml-2"
              >
                {!entry?.value ? 'Yes': 'No'}
              </button>
            </div>
          )
          : (
            <input
              className="editableDataCellInput"
              onFocus={this.handleFocus}
              // autoFocus //todo read-311
              name="value"
              type="number"
              onChange={onStudentRowEditingChange(
                evidenceColumnGroupId,
                evidenceColumn.id,
                student.id!
              )}
              value={
                studentRowEditing.value !== undefined
                  ? +studentRowEditing.value
                  : ""
              }
              onKeyDown={onKeyDown(
                evidenceColumnGroupId,
                evidenceColumn.id,
                student.id!
              )}
            />
          )}
          <div className="editableDataCellOptions">
            {isCategoryType ? (
              <Button
                onClick={onCellEditFormChange(
                  evidenceColumnGroupId,
                  evidenceColumn.id,
                  student.id!
                )}
                style={{ marginTop: -5 }}
              >
                <FontAwesomeIcon icon={faTimesCircle} className="pointer" />
              </Button>
            ) : (evidenceColumn.evidence_type != EvidenceType.DiagnosticFollowUp) && (
              <>
                <Button
                  onClick={onCellEditFormChange(
                    evidenceColumnGroupId,
                    evidenceColumn.id,
                    student.id!
                  )}
                >
                  <FontAwesomeIcon icon={faTimesCircle} className="pointer" />
                </Button>
                {this.props.loadingValueOfDSEtoDataPeriod ? (
                  <Spinner animation="border" size="sm" className="m-1"/>
                ) : (
                <Button
                  onClick={onChangesApply(
                    evidenceColumnGroupId,
                    evidenceColumn.id,
                    student.id!,
                    studentRowEditing.value
                  )}
                  disabled={this.props.loadingValueOfDSEtoDataPeriod}
                >
                  <FontAwesomeIcon icon={faCheckCircle} className="pointer" />
                </Button> 
                )}
              </>
            )}
          </div>
        </div>
      </div>
    ) : entry && (evidenceColumn.evidence_type != EvidenceType.BehaviorScreener) ? (
      <Cell
        onDoubleClick={
          isDataEvidence && !entry.gating_file_value
            ? onCellEditFormChange(
                evidenceColumnGroupId,
                evidenceColumn.id,
                student.id!,
                entry.value
              )
            : () => null
        }
        onClick={
          !this.props.isReadonly &&
          evidenceColumn.evidence_type === EvidenceType.DiagnosticInfo
            ? () => this.props.openSkillFocusesModal(entry)
            :  (!this.props.isReadonly &&
                evidenceColumn.evidence_type === EvidenceType.DiagnosticFollowUp)
            ? onCellEditFormChange(
              evidenceColumnGroupId,
              evidenceColumn.id,
              student.id!,
              entry.value
            )
            :() => null
        }
        className="dataTableCell"
      >
        <DataCell
          key={`${entry.entry_id}-${entry.student_id}-${entry.grade}`}
          isReadonly={this.props.isReadonly}
          studentEntry={entry}
          evidenceColumn={evidenceColumn}
          dataPeriod={dataPeriod}
          showConfirmDialog = {this.props.showConfirmDialog}
          deleteStudentScoreEntry = {this.props.deleteStudentScoreEntry}
          onCellEditFormChange = {onCellEditFormChange(
            evidenceColumnGroupId,
            evidenceColumn.id,
            student.id!,
            entry.value
          )}
        />
      </Cell>
    ) : evidenceColumn.evidence_type === EvidenceType.Interview ? (
      <InterviewEntryCell studentId={student.id!} />
    ) : (
      this.getEmptyCell(evidenceColumnGroupId, evidenceColumn, student, entry)
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      openSkillFocusesModal: openSkillFocusesModal,
      showConfirmDialog: showConfirmDialog,
      deleteStudentScoreEntry: deleteDataStudentEntry,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(DataStudentEntryCell);
